import moment from 'moment';
import { getPercentages } from '../../Colors/percentages';
import {trainingAPI} from '../../api/TrainingAPI';
import { 
  getRestTravelLabel,
  getBarColorsForHighcharts,
  getTestingColorFromZScore,
  getBarWeightMetric,
  isVBTMetric,
  getValueColor,
  getRestAndTravelDaysInChart,
  addPredictionSeriesConfig
} from '../../Utils/chart_utils';
import { get_unit, get_dist_unit } from "../../Utils/unit.js";


export const mapDataForScatterplot = ({
  data = [],
  colors = [],
  xPlotlines = [],
  yPlotlines = [],
  xAxisMetricName = '',
  yAxisMetricName = ''
}) => {

    const options = createOptions({
        seriesList: data,
        colors,
        xPlotlines,
        yPlotlines,
        xAxisMetricName,
        yAxisMetricName,
    });

    return options;
};

export const createOptions = ({
    seriesList = [],
    xPlotlines = [],
    yPlotlines = [],
    xAxisMetricName = '',
    yAxisMetricName = '',
    tooltip = {},
    colors,
    show,
    showHamburger = true
}) => {
  
  tooltip = {
    ...tooltip,
    shared: true,
    formatter: function () {
      const dateLine = `<strong>${this.point?.date}</strong> <br>`
      const gameDate = this.point?.gameday ? `${this.point.gameday} <br>` : ''
      const nameLine = this.point?.name ? `${this.point?.name} <br>` : ''
      const positionLine = this.point?.position ? `${this.point?.position} <br>` : ''
      const xLine = `${xAxisMetricName}: ${this.point?.x} <br>`
      const yLine = `${yAxisMetricName}: ${this.point?.y}`
      return dateLine + gameDate + nameLine + positionLine + xLine + yLine;
    }
  }

  const options = {
    chart: {
      type: 'scatter',
      zoomType: 'xy'
    },
    title: {
      text: `${xAxisMetricName} by ${yAxisMetricName}`
    },
    xAxis: {
      title: {
        text: xAxisMetricName
      },
    //   gridLineWidth: 2,
    //   labels: {
    //     format: '{value} x'
    //   },
    //   tickWidth: 1,
    plotLines: [],
    //   startOnTick: true,
    //   endOnTick: true,
    //   showLastLabel: true
    },
    yAxis: {
        title: {
            text: yAxisMetricName
        },
        // tickAmount: 6,
        plotLines: [],
        // labels: {
        //   format: '{value} y'
        // },
    },
    legend: {
      enabled: true,
      verticalAlign: 'top',
      layout: 'horizontal'
    },
    plotOptions: {
        scatter: {
            marker: {
                radius: 2.5,
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        lineColor: 'rgb(100,100,100)'
                    }
                }
            },
            states: {
                hover: {
                    marker: {
                        enabled: false
                    }
                }
            },
            jitter: {
                x: 0.005
            }
        }
    },
    colors,
    series: seriesList,
    tooltip,
    exporting: {
      enabled: showHamburger, // Enables the export button
      chartOptions: { // specific options for the exported image
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: false
                }
            }
        }
      },
      fallbackToExportServer: false
    },
  };

  if (xPlotlines.length) {
    xPlotlines.forEach( (plotlineValue, index) => {
      plotlineValue = parseFloat(plotlineValue)?.toFixed(2)
      const plotline = {
        id: `x-${index}`,
        dashStyle: 'ShortDash',
        color: 'black',
        value: plotlineValue,
        zIndex: 5,
        label: {
          text: plotlineValue,
          rotation: 0,
          style: {
            zIndex: 60001 
          }
        }
      }
      options.xAxis.plotLines.push(plotline);
    })
  }

  if (yPlotlines.length) {
    yPlotlines.forEach( (plotlineValue, index) => {
      plotlineValue = parseFloat(plotlineValue)?.toFixed(2)
      const plotline = {
        id: `y-${index}`,
        dashStyle: 'ShortDash',
        color: 'black',
        value: plotlineValue,
        zIndex: 5,
        label: {
          text: plotlineValue,
          align: 'right',
          style: {
            zIndex: 60001 
          }
        }
      }
      options.yAxis.plotLines.push(plotline);
    })
  }

  return options;
};
